import logo from './logo.png';
import mobilelogo from './mobilelogo.png';
import sliderimg1 from './women-presenting.jpg';
import sliderimg2 from './construction-worker-at-windmill-farm.jpg';
import sliderimg3 from './slider3.png';
import sliderimg4 from './slider2.png';
import whoarewe1 from './men-working.jpg';
import whoarewe2 from './office-interior.jpg';
import project1 from './project1.png';
import project2 from './project2.jpg';
import project3 from './project3.jpg';
import project4 from './project4.jpg';
import client1 from './client-1.jpg';
import client2 from './client-2.png';
import blogimg1 from './blog1.jpg';
import blogimg2 from './blog2.jpg';
import blogimg3 from './blog3.jpg';
import heroimgmobile from './heroimgmobile.png';
import welcomeimg from './welcomeimg.png';
import mission1 from './missionimg1.png';
import mission2 from './missionimg2.png';
import workflow1 from './workflow1.png';
import workflow2 from './workflow2.png';
import workflow3 from './workflow3.png';
import workflow4 from './workflow4.png';
import founder from './founder.png';
import aboutbanner from './aboutbanner.png';
import servicebanner from './servicebanner.png';
import portfoliobanner from './portfoliobanner.png';
import blogbanner from './blogbanner.png';


export const images = {
    logo,
    heroimgmobile,
    sliderimg1,
    sliderimg2,
    sliderimg3,
    sliderimg4,
    whoarewe1,
    whoarewe2,
    project1,
    project2 ,
    project3,
    project4,
    client1,
    client2,
    blogimg1,
    blogimg2,
    blogimg3,
    welcomeimg,
    mission1,
    mission2,
    workflow1,
    workflow2,
    workflow3,
    workflow4,
    founder,
    aboutbanner,
    servicebanner,
    portfoliobanner,
    blogbanner,
    mobilelogo,
};